import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=389d4107&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=389d4107&prod&lang=scss&scoped=true"
import style1 from "./AdminLayout.vue?vue&type=style&index=1&id=389d4107&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d4107",
  null
  
)

export default component.exports